export default "assets/images/icons/tel-fba43df1.svg";